import React from 'react';
import cn from 'classnames';

import { Upload as AntUpload } from 'antd';
import { UploadProps } from 'antd/lib/upload';

import styles from './Upload.module.scss';

import { Dragger } from './Dragger';

export interface IUploadProps extends UploadProps {}

type TUpload = React.FC<IUploadProps> & {
  Dragger: typeof Dragger;
};
/**
 * Uploading Selector.
 */
export const Upload: TUpload = ({ className, ...props }) => (
  <AntUpload className={cn(styles.Upload, className)} {...props} />
);

Upload.Dragger = Dragger;
